import { render, staticRenderFns } from "./MenuVoucher.vue?vue&type=template&id=a3e32c2c&"
import script from "./MenuVoucher.vue?vue&type=script&lang=js&"
export * from "./MenuVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports